module.exports = __webpack_public_path__ + "img/weya5.764d2615.png";